import { createContext } from 'react';

export interface CsrfContextValue {
  token: Maybe<string>;
  setToken: (token: string) => void;
}

/**
 * CSRF Token Context
 *
 * Provides CSRF token and a setter for updating it when refreshed.
 * The token is initially set from SSR props and can be refreshed
 * client-side when it becomes stale.
 */
export const CsrfTokenContext = createContext<CsrfContextValue>({
  token: undefined,
  setToken: () => {
    // no-op default - will be overridden by provider
  },
});
